import { render } from "./addWarehouseProduct.vue?vue&type=template&id=21951d5d&scoped=true"
import script from "./addWarehouseProduct.vue?vue&type=script&lang=js"
export * from "./addWarehouseProduct.vue?vue&type=script&lang=js"

import "./addWarehouseProduct.vue?vue&type=style&index=0&id=21951d5d&scoped=true&lang=css"

import exportComponent from "C:\\projects\\carenvisitorapp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21951d5d"]])

export default __exports__